import classNames from "classnames";
import "./index.css";

export const TypingLoader = ({ className }) => (
  <div className={classNames("typing flex items-center", className)}>
    <div className="typing__dot"></div>
    <div className="typing__dot"></div>
    <div className="typing__dot"></div>
  </div>
);
